import * as React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { MaximalLayout } from "@ui-seeker/app"
import { SlaaskPlugin } from "@ui-seeker/slaask-plugin"

import { ANALYTICS_ROUTES, SESSIONS_ROUTES } from "@constants"
import { useManualLink, useRoutesApp, useUserApp } from "@hooks"
import { userData, hasAiInsights } from "@signals"
import { appConfig, styles } from "./config"
import DonwloadManualButton from "./DownloadManualButton"
import {
    AiInsightsDrawer,
    AiInsightsFloatingTab,
    Announcements,
    AnnouncementsBell,
    DipiBrandsChatWidget
} from "@components"


// DIPI Brands chatbot: enabled only for these customers
const DIPI_BRANDS_AGENT_CUSTOMER_IDS = [6, 30, 16, 34, 24]


export default function AppLayout() {
    const { pathname, search } = useLocation()
    const { routesMenuApp } = useRoutesApp()
    const { isLogged, userAccess } = useUserApp(true)
    const { manualLink } = useManualLink(userData.value)

    const userLinks = userAccess.includes("analytic") 
        ? [{ url: ANALYTICS_ROUTES.PATH, icon: "magnifying-glass-chart", text: "My Scope" }]
        : []

    if (!isLogged)
        return <Navigate to={`${SESSIONS_ROUTES.LOGIN_URL}?redirect=${pathname}${search}`} replace />

    return <>
        <MaximalLayout
            routes={routesMenuApp} 
            config={appConfig} 
            userData={userData.value} 
            // The bell is always there; the manual button only when the customer has a manual.
            // Composed rather than conditional on the whole slot, which is what this was
            // before — passing `{}` would take the bell out along with the button.
            components={{
                headerTools: <>
                    {!!manualLink && <DonwloadManualButton manualLink={manualLink} />}
                    <AnnouncementsBell />
                </>
            }}
            styles={styles}
            links={userLinks}
        />
       
        {/* The news popup. Mounted here so it appears on whatever page the user lands on,
            and it renders nothing when there is nothing pending — which is most of the time.
            Its hook swallows its own errors: an announcement must never stand between the
            user and their dashboard. */}
        <Announcements />

        {hasAiInsights.value && <>
            <AiInsightsFloatingTab />
            <AiInsightsDrawer />
        </>}

        <SlaaskPlugin
            widgetKey="spk-d2358d18-33fd-40da-8da6-25fcf50b7577"
            name={userData.value.username}
        />

        {DIPI_BRANDS_AGENT_CUSTOMER_IDS.includes(userData.value?.customerID) &&
            <DipiBrandsChatWidget
                customer={userData.value.customerID}
                username={userData.value.username}
            />
        }
    </>
}